import { Observable } from 'rxjs';
import { InitializeService } from '../services/initialize.service';

export function loadConfiguration(initializeService: InitializeService): () => Observable<any> {
  return () => initializeService.initialize();
}
